import { useContext, useState } from "react";
import { client } from "../../../../api";
import { ModalContext } from "../../../../contexts/modal.context";
import { Link } from "../../../Link";

export const SimpleInputModalTableItem = ({ disabled, abbrev=false, labelText, endpoint, value, fieldName, identifyingData, updateOrders=()=>{} }) => {
  const { openModal } = useContext(ModalContext);
  const [edited, setEdited] = useState(false);

  const handleEditClick = () => {
    openModal({
      prompt: labelText,
      onSave: (value) => {
        const editOrder = async () => {
          identifyingData[fieldName] = value;
  
          await client({
            method: 'POST',
            url: endpoint,
            headers: {
              "Content-Type": "application/json",
            },
            data: identifyingData,
          });
          await updateOrders(identifyingData);
          setEdited(true);
          setTimeout(() => {
            setEdited(false);
          }, 2000);
        };
        
        editOrder();
      }
    });
  };

  switch (fieldName) {
    case "phoneNumber":
      return <div className={`table-cell text-right text-xxs rounded-md pl-2 ${disabled ? 'text-gray-500 cursor-default' : !edited ? 'text-blue-500 underline cursor-pointer' : 'text-white bg-green-500'}  `} onClick={disabled ? () => {} : handleEditClick}>
          {!edited ? (value ? `(${value.slice(0,3)}) ${value.slice(3,6)}-${value.slice(6,10)}` : 'Undefined') : 'edited!'}
      </div>;
    case "googleSheetId":
      return <div className={`table-cell text-right text-xxs rounded-md pl-2 ${disabled ? 'text-gray-500 cursor-default' : !edited ? 'text-blue-500 underline cursor-pointer' : 'text-white bg-green-500'}  `} onClick={disabled ? () => {} : handleEditClick}>
          {!edited ? (value && abbrev ? value.slice(-20) : value ? value : 'Undefined') : 'edited!'}
      </div>;
    case "calendarUrl":
      return <div className={`table-cell text-center relative`} >
        <div className="flex grow items-center justify-center mt-2">
          <div className={`${value ? 'bg-green-500 rounded-md w-5 text-white' : 'w-6'} cursor-pointer p-1`} onClick={disabled ? () => {} : handleEditClick}>
          <Link>{value}</Link>
          </div>
          </div>
      </div>;
    default:
      return <div className={`table-cell text-right text-xxs rounded-md pl-2 ${disabled ? 'text-gray-500 cursor-default' : !edited ? 'text-blue-500 underline cursor-pointer' : 'text-white bg-green-500'}  `} onClick={disabled ? () => {} : handleEditClick}>
          {!edited ? (value && abbrev ? value.slice(-20) : value ? value : 'Undefined') : 'edited!'}
      </div>;
  }
};

// export const SimpleInputModalTableItem = ({ labelText, endpoint, value, fieldName, identifyingData, updateOrders=()=>{} }) => {
//   const [edited, setEdited] = useState(false);
//   const [inputValue, setInputValue] = useState(value?.toString());

//   useEffect(() => {
//     setInputValue(value?.toString());
//   }, [value]);

//   const handleEditClick = () => {
//     const modal = document.querySelector("#orderedEditModal");
//     const header = modal.getElementsByTagName("h2")[0];
//     const input = modal.getElementsByTagName("input")[0];
//     const saveButton = modal.getElementsByTagName("button")[0];
//     const closeButton = modal.getElementsByTagName("button")[1];

//     header.textContent = labelText;
//     input.value = '';
//     input.selectionStart = input.selectionEnd = input.value.length;
//     modal.showModal();

//     const onSaveChange = () => {
//       const editOrder = async () => {
//         identifyingData[fieldName] = input.value;

//         await client({
//           method: 'POST',
//           url: endpoint,
//           headers: {
//             "Content-Type": "application/json",
//           },
//           data: identifyingData,
//         });
//         setInputValue(input.value);
//         updateOrders(identifyingData);
//         setEdited(true);
//         setTimeout(() => {
//           setEdited(false);
//         }, 2000);
//       };

//       if (input.value !== inputValue) {
//         editOrder();
//       }
      
//       saveButton.removeEventListener("click", onSaveChange);
//       closeButton.removeEventListener("click", handleClose);
//       modal.removeEventListener("cancel", handleClose);
//       modal.close();
//     }

//     const handleClose = (event) => {
//       event.preventDefault();

//       saveButton.removeEventListener("click", onSaveChange);
//       closeButton.removeEventListener("click", handleClose);
//       modal.removeEventListener("cancel", handleClose);
//       modal.close();
//     };

//     saveButton.addEventListener("click", onSaveChange);
//     closeButton.addEventListener("click", handleClose);
//     modal.addEventListener("cancel", handleClose);
//   };

//   return (
//     <div className={`table-cell text-right text-xs rounded-md pl-2 font-medium ${!edited ? 'text-blue-500 underline' : 'text-white bg-green-500'} cursor-pointer `} onClick={handleEditClick}>
//       {!edited ? inputValue : 'edited!'}
//     </div>
//   );
// };